import styled from "styled-components";
import chevronSvg from "./icons/chevron.svg";

export const Chevron = styled.div`
    width: 20px;
    height: 20px;
    mask-image: url("${chevronSvg}");
    mask-size: contain;
    mask-repeat: no-repeat;
    background-color: currentColor;
    transform: rotate(0deg);
    transition: transform 0.2s cubic-bezier(0.39, 0.575, 0.565, 1);
    &[data-active='true'] {
        transform: rotate(180deg);
    }
`;
